import { render, staticRenderFns } from "./TableNav.vue?vue&type=template&id=65ec5025&"
import script from "./TableNav.vue?vue&type=script&lang=js&"
export * from "./TableNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports